import { formatDate as canonicalFormatDate } from "@/libs/i18n/format-date";
import { Traveller } from "@/types/Traveller";

export function formatDate(dateString: string | undefined) {
  return canonicalFormatDate(dateString, "dd/MM/yy");
}
export function getNumberOfDates(
  startDate: string | undefined,
  endDate: string | undefined
) {
  let start;
  let end;
  if (startDate && endDate) {
    start = new Date(startDate);
    end = new Date(endDate);
    const differenceInTime = end.getTime() - start.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays + 1;
  }
  return 0;
}

export function checkMissingEncryptedId(travellers: Traveller[] | undefined) {
  if (!travellers) {
    return false;
  }
  const hasMissingEncryptedId = travellers.some(
    (traveller) =>
      !Object.prototype.hasOwnProperty.call(traveller, "encryptedId") ||
      traveller.encryptedId === undefined
  );
  return hasMissingEncryptedId;
}
